<template>
  <div class="execution">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="员工管理" name="first"></el-tab-pane>
        <el-tab-pane label="角色管理" name="second"></el-tab-pane>
      </el-tabs>

      <div class="index" v-show="!addStaffVisible">
        <div class="oper">
          <el-button
            type="primary"
            v-if="permissions['chain:companystaff:add']"
            @click="editStaff({})"
            >添加员工</el-button
          >
          <div class="right">
            <el-select
              v-model="paramsSearch.companyPositionId"
              placeholder="请选择"
              style="margin-right: 16px"
              @change="searchChange"
            >
              <el-option
                v-for="item in roles"
                :key="item.id"
                :label="item.positionName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="paramsSearch.status"
              placeholder="请选择"
              style="margin-right: 16px"
              @change="searchChange"
            >
              <el-option
                v-for="item in states"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="tel">
              <el-input
                placeholder="请输入手机号"
                v-model="paramsSearch.mobile"
                class="input-with-select"
                :maxlength="11"
                type="number"
              >
                <div class="label" slot="prepend">手机号</div>
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchChange"
                ></el-button>
              </el-input>
            </div>
            <!-- <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          </div>
        </div>
        <my-crud
          ref="crud"
          :page.sync="page"
          :data="tableData"
          :permission="permissionList"
          :table-loading="tableLoading"
          :option="tableOption"
          v-model="form"
          @on-load="getPage"
          @refresh-change="refreshChange"
          @row-update="handleUpdate"
          @row-save="handleSave"
          @row-del="handleDel"
          @sort-change="sortChange"
          @search-change="searchChange"
        >
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              v-if="permissions['chain:companystaff:edit']"
              size="small"
              plain
              @click="editStaff(scope.row, scope.index)"
            >
              编辑</el-button
            >
            <el-button
              type="text"
              v-if="permissions['chain:companystaff:del']"
              size="small"
              plain
              @click="handleDel(scope.row, scope.index)"
            >
              禁用</el-button
            >
            <el-button
              type="text"
              v-if="permissions['chain:companystaff:manage']"
              size="small"
              plain
              @click="projectManage(scope.row, scope.index)"
            >
              管理项目</el-button
            >
          </template>
        </my-crud>
      </div>

      <!-- 批量设置班次 -->
      <project-manage
        v-if="manageVisible"
        :info="info"
        :visible.sync="manageVisible"
      ></project-manage>

       <!-- 批量设置班次 -->
       <add-staff
        v-if="addStaffVisible"
        :info="info"
        :roles="newRoles"
        :menus="menusData"
        :visible.sync="addStaffVisible"
        @saveSuccess="saveSuccess"
      ></add-staff>
    </basic-container>
  </div>
</template>

<script>
import {
  getPage,
  getObj,
  addObj,
  putObj,
  delObj,
  tree,
  getRoles,
} from "@/api/chain/companystaff";
import { tableOption } from "@/const/crud/chain/companystaff2";
import { mapGetters } from "vuex";
import projectManage from "./projectManage.vue";
import addStaff from './add.vue'
import { systemmenu } from "@/api/chain/companyposition";
export default {
  name: "companydept2",
  data() {
    return {
      tableKey:0,
      menusData:[],
      newRoles:[],
      addStaffVisible:false,
      manageVisible: false,
      info: {},
      roles: [],
      states: [
        {
          value: "",
          label: "全部状态",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "0",
          label: "无效",
        },
      ],
      activeName: "first",
      treeOption: {
        nodeKey: "id",
        addBtn: false,
        menu: false,
        defaultExpandAll: true,
        props: {
          label: "deptName",
          value: "id",
        },
      },
      treeOrganData: [],
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {
        status: "",
        companyPositionId: "",
        mobile: "",
      },
      tableLoading: false,
      tableOption: tableOption,
    };
  },
  created() {
    // this.getTree();
    // this.getPage(this.page)
    this.getRoles();
    systemmenu().then((res) => {
     
     this.addDisabledAttribute(res.data.data);
    this.menusData=res.data.data
   });
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  components: {
    projectManage,
    addStaff
  },
  methods: {
    
    saveSuccess(){
      this.addStaffVisible=false
      this.searchChange()
    },
    addDisabledAttribute(array) {
      array.forEach((item) => {
        item.disabled = true; // 添加 disabled 属性
        if (item.children && Array.isArray(item.children)) {
          this.addDisabledAttribute(item.children); // 递归处理子数组
        }
      });
    },
    editStaff(row){
        this.info=row
        this.addStaffVisible=true
    },
    addStaff() {
      this.$router.push({ path: "/chain/enterprise/companystaff/add" });
    },
    projectManage(row) {
      this.info = row;
      this.manageVisible = true;
    },
    getRoles() {
      getRoles().then((res) => {
        this.newRoles= JSON.parse(JSON.stringify(res.data.data))
        this.roles = res.data.data;
        this.roles.unshift({
          positionName: "全部角色",
          id: "",
        });
      });
    },
    tabClick(e) {
      if (e.name == "second") {
        this.$router.push({ path: "/chain/enterprise/companyposition2" });
      }
    },
    searchChange(params, done) {
      // params = this.filterForm(params);
      // this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    permissionList(key, row, index) {
      if (key === "editBtn") {
        return this.permissions["chain:companydept:edit"] && row.deptType != 1
          ? true
          : false;
      } else if (key === "delBtn") {
        return this.permissions["chain:companydept:del"] && row.deptType != 1
          ? true
          : false;
      } else if (key === "addBtn") {
        return this.permissions["chain:companydept:add"] ? true : false;
      }
      return true;
    },
    nodeClick(data) {
      this.page.currentPage = 1;
      this.getPage(this.page, { parentDeptId: data.id });
    },
    getChildren(item) {
      if (item.children) {
        if (item.children.length > 0) {
          item.children.map((itss) => {
            itss.deptName = `${itss.deptName}(${itss.count})`;
            this.getChildren(itss);
          });
        }
      }
    },
    getTree() {
      tree().then((res) => {
        console.log(res.data.data);
        // let arr = [];
        // res.data.data.map((item) => {
        //   item.deptName = `${item.deptName}`;   //`${item.deptName}(${item.count})`;
        //   item.children.map((its) => {
        //     its.deptName = `${its.deptName}`;  //`${its.deptName}(${its.count})`;
        //     this.getChildren(its)
        //   });
        // });
        this.treeOrganData = res.data.data;
        console.log(this.$refs.crud);
        // this.$refs.crud.DIC.parentDeptId = res.data.data
        // const index = this.$refs.crud.findColumnIndex('parentDeptId');
        let column = this.tableOption.column[4];
        column = Object.assign(column, {
          dicData: res.data.data,
        });
        // setTimeout(()=>{
        //   this.$refs.crud.updateDic("parentDeptId",res.data.data)
        // },1000)
      });
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
          // this.getTree();
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      console.log("rows", row);
      // console.log("row.leadingId", row.leadingId);
      // row.leadingId = row.leadingId.join(",");
      // row.staffList = row.staffList.join(',')
      //
      // row.idList = row.staffList;
      // delete row.staffList;
      // console.log('row',row)
      if (row.parentDeptId == row.id) {
        this.$message.error("上级部门不能为自己");
        loading();
        return false;
      }
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
          // this.getTree();
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      console.log("rows", row);

      // row.leadingId = row.leadingId.join(",");
      // row.idList = row.staffList;
      // delete row.staffList;
      // delete row.idList;
      console.log("row", row);
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
          // this.getTree();
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.oper {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .right {
    display: flex;
    margin-left: auto;
    /deep/.el-select .el-input__inner {
      width: 104px;
      height: 32px;
    }
    /deep/.el-input--medium .el-input__inner {
      line-height: 32px;
      width: 104px;
      height: 32px;
    }
  }
}
/deep/.el-card {
  border: none;
}
/deep/.plTableBox .el-table td,
.plTableBox .el-table th.is-leaf {
  border-bottom: 1px solid #ededf0;
  background: #fff !important;
  font-weight: 400;
  font-size: 14px;
  color: #626266;
}
/deep/.el-table__header th.is-leaf {
  border: none;
  background: #F5F7FA;
  font-weight: 500;
  font-size: 14px;
  color: #313133;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #fff;
}

/deep/.el-input-group__append {
  width: 30px;
  height: 30px;
  background: #F5F7FA;
  border-radius: 0px 3px 3px 0px;
  border: 1px solid #ededf0;
  padding: 0;
  text-align: center;
}
/deep/.el-input-group__prepend {
  padding: 0;
  width: 103px;
  height: 30px;
  background: #fff;
  .label {
    display: flex;
    align-items: center;
    justify-content: center;

    background: #ffffff;
    // border-radius: 3px 0px 0px 3px;
    // border: 1px solid #EDEDF0;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
.tel {
  /deep/.el-input {
    input {
      width: 182px !important;
    }
  }
}
</style>
